// extracted by mini-css-extract-plugin
export default {"root":"DataConnectorPickerButton_root__ZLXgB","label":"DataConnectorPickerButton_label__nN+q3","name":"DataConnectorPickerButton_name__q0PRR"};